import styled from 'styled-components';

export const LoadingContainer = styled.div`
  border: 1px solid #ddd;
  background: #fff;
  height: 40px;
  width: 100%;
  border-radius: ${({ borderRadius }) => borderRadius || '3px'};
`;
